import React from "react";
import { Toaster as Sonner, ToasterProps } from "sonner";
import { useSelector } from "react-redux";
import { resolveColorMode } from "utils/colorMode";

const Toaster = ({ ...props }: ToasterProps) => {
  const layoutMode = useSelector((state: any) => state.Layout.layoutModeType);

  return (
    <Sonner
      theme={resolveColorMode(layoutMode)}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
